import { ICellRendererParams } from "ag-grid-community";
import { Settings } from "lucide-react";
import React from "react";

import { IgIconButton } from "@intelligems/ig-theme";
import { OrganizationSummarySubscriptionProductDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { useGetBillingPortal } from "@src/api/stripe/get-billing-portal";
import { useLoggedInUser } from "@src/api/user-auths/login";

export const SettingsColumn = (
  params: ICellRendererParams<OrganizationSummarySubscriptionProductDto>
) => {
  const context: { showAll?: boolean } = params.context;
  const orgSummary = useGetOrganizationSummary();
  const getBillingPortal = useGetBillingPortal(false);
  const user = useLoggedInUser();

  if (!params.data) {
    return null;
  }

  if (
    !context.showAll &&
    (!params.data.stripeSubscriptionId || !orgSummary.isSuccess)
  ) {
    return null;
  }

  if (orgSummary.data.org.agencies.length) {
    if (!params.data.subscriptionSummary?.agencyEmails?.length) {
      return null;
    }
    if (
      params.data.subscriptionSummary.agencyEmails.every(
        (email) => email !== user.data?.user?.email
      )
    ) {
      return null;
    }
  }

  if (params.data.subscriptionSummary?.billingProvider === "shopify") {
    return null;
  }

  return (
    <Grid item>
      <IgIconButton
        size={"small"}
        loading={getBillingPortal.isPending}
        onClick={() => {
          getBillingPortal.mutate({
            body: {
              stripeSubscriptionId: params.data!.stripeSubscriptionId!,
            },
            queryParams: undefined,
            pathParams: undefined,
          });
        }}
      >
        <Settings size={18} />
      </IgIconButton>
    </Grid>
  );
};
